import { __exports as t } from "./index799.mjs";
t.f = Object.getOwnPropertySymbols;
export {
  t as default
};
